// extracted by mini-css-extract-plugin
export default {"Slider":"Slider_Slider__P1QXZ","Slider__Left":"Slider_Slider__Left__Z0dN9","Slider__Right":"Slider_Slider__Right__rMVUV"};